import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'product-carousel',
  templateUrl: './product-carousel.component.html',
  styleUrls: ['./product-carousel.component.scss'],
})
export class ProductCarouselComponent implements OnInit {
  @Input() productCarouselInfo: any;
  @Output() navigateToDetail = new EventEmitter<any>();
  constructor(
    private navController: NavController,
  ) { }

  ngOnInit() { }
  async navigate(productItem: any) {
    if (productItem?.landingType === 'external_url') {
      await Browser.open({ url: productItem?.landingValue });
    }
    else if(productItem?.landingType === 'url'){
      this.navController.navigateForward(productItem?.landingValue);
    }
    else{
      this.navigateToDetail.emit(productItem);
    }
  }
}
